import { Link } from "react-router-dom";
import { Linkedin, Mail, Lock } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[var(--bg-primary)] border-t border-[rgba(124,58,237,0.1)] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-3 font-brand text-lg uppercase tracking-[0.2em] text-white" data-testid="footer-logo">
              <img src="/logo-rc-sm.png" alt="RC" className="h-10 w-auto" />
              Raulvin Coke
            </Link>
            <p className="text-sm text-[var(--text-secondary)] mt-3 leading-relaxed">
              Futurist. Founder. Speaker.<br />
              AI, Adaptive Intelligence & the Future of Human Decision-Making.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Explore</h4>
            <div className="space-y-2">
              {[
                { label: "Intelligence", href: "/intelligence" },
                { label: "Research", href: "/research" },
                { label: "Adaptive Intelligence", href: "/adaptive-intelligence" },
                { label: "About", href: "/about" },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="block text-sm text-[var(--text-secondary)] hover:text-white transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Engage */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Engage</h4>
            <div className="space-y-2">
              {[
                { label: "Speaking", href: "/speaking" },
                { label: "Boards & Advisory", href: "/boards" },
                { label: "Media", href: "/media" },
                { label: "Contact", href: "/contact" },
              ].map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="block text-sm text-[var(--text-secondary)] hover:text-white transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-sm font-semibold text-white mb-4 uppercase tracking-wider">Connect</h4>
            <div className="flex gap-3">
              {[
                { icon: Linkedin, href: "https://www.linkedin.com/in/raulvin-coke-705189392/", id: "linkedin" },
                { icon: Mail, href: "mailto:rcoke@raulvincoke.com", id: "email" },
              ].map(({ icon: Icon, href, id }, i) => (
                <a
                  key={i}
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  aria-label={id}
                  data-testid={`footer-${id}-link`}
                  className="w-10 h-10 rounded-lg border border-[rgba(124,58,237,0.15)] flex items-center justify-center text-[var(--text-secondary)] hover:text-[var(--accent-violet-light)] hover:border-[var(--accent-violet)] transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[rgba(124,58,237,0.1)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[var(--text-secondary)]">
            &copy; {new Date().getFullYear()} Raulvin Coke. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <p className="text-xs text-[var(--text-secondary)]">
              Founder & CEO, Agentic FuturePath AI
            </p>
            <Link to="/admin/login" aria-label="Admin sign in" title="Admin" className="flex items-center gap-1 text-xs text-[var(--text-secondary)]/50 hover:text-[var(--accent-violet-light)] transition-colors" data-testid="footer-admin-link">
              <Lock className="w-3 h-3" /> Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
